/**
 * @typedef {'draft'|'published'} StoryblokVersion
 */

/**
 * @enum {StoryblokVersion}
 * @type {Object.<string, StoryblokVersion>}
 */
export const STORYBLOK_VERSION = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
};
